import { render, staticRenderFns } from "./medicaldevices-wearables.vue?vue&type=template&id=f3d70d3e&scoped=true&"
import script from "./medicaldevices-wearables.vue?vue&type=script&lang=js&"
export * from "./medicaldevices-wearables.vue?vue&type=script&lang=js&"
import style0 from "./medicaldevices-wearables.vue?vue&type=style&index=0&id=f3d70d3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d70d3e",
  null
  
)

component.options.__file = "medicaldevices-wearables.vue"
export default component.exports